import {
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import { statisticsApi } from "api";
import React, { useCallback, useEffect, useState } from "react";
import ProcessesList from "./ProcessesList";
import { StartedProcess } from "./ProcessItem";
import {
  useForm,
  useInfiniteScroll,
  useProcessModels,
  useTranslations,
} from "hooks";
import { getQueryParams, getTranslation } from "common";
interface ProcessStartedProps {
  organizationId: number;
}

const ProcessStarted: React.FC<ProcessStartedProps> = ({ organizationId }) => {
  const translations = useTranslations();
  const [processes, setProcesses] = useState<Array<StartedProcess>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { processModels, modelsLoading } = useProcessModels();
  const [toDo, setToDo] = useState<boolean>(true);
  const [doing, setDoing] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const lastElementRef = useInfiniteScroll(setPage, loading, hasMore);
  const { values, changeHandler } = useForm(
    {
      status: "current",
      modelid: "",
    },
    []
  );

  const search = useCallback(async (_page: number = 0) => {
    // setProcesses([]);
    setLoading(true);
    try {
      const filteredValues = Object.fromEntries(
        Object.entries(values).filter(
          ([key, value]) => value && key !== "status"
        )
      );
      const queryParams = getQueryParams({
        ...filteredValues,
        page: 1,
        pageSize: 10 * (_page ? _page : page),
      });
      const { data } = await statisticsApi.get(
        `${values.status}/${organizationId}?${queryParams}`
      );
      setProcesses(data.data);
      setHasMore(data.meta.hasMore);
      // data.map((_: any) => ({ ..._.process, tasks: _.details }))
    } catch {
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, organizationId]);

  useEffect(() => {
    const value = doing && toDo ? "current" : doing ? "doing" : "todo";
    changeHandler("status", value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doing, toDo]);

  useEffect(() => {
    if (page) {
      search();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    setPage(0);
  }, [values]);

  useEffect(() => {
    if (!page) {
      setPage(1);
    }
  }, [page]);

  const refresh = () => {
    if(page === 1) {
      search(1);
    } else {
      setPage(1);
    }
  };

  return (
    <Stack height="100%" spacing={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} lg={4}>
          <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
            <FormControlLabel
              control={
                <Switch
                  checked={doing}
                  onChange={({ target }) => {
                    if (!toDo && !target.checked) {
                      setToDo(true);
                    }
                    setDoing(target.checked);
                  }}
                />
              }
              label={getTranslation(
                translations,
                "pm.label.process_status.doing"
              )}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={toDo}
                  onChange={({ target }) => {
                    if (!doing && !target.checked) {
                      setDoing(true);
                    }
                    setToDo(target.checked);
                  }}
                />
              }
              label={getTranslation(
                translations,
                "pm.label.process_status.todo"
              )}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          {!modelsLoading && (
            <TextField
              select
              fullWidth
              label={getTranslation(translations, "pm.modelname.label.caption")}
              size="small"
              onChange={({ target }) => changeHandler("modelid", target.value)}
              value={values.modelid}
            >
              <MenuItem value="">
                {getTranslation(translations, "generic.all")}
              </MenuItem>
              {processModels.map((processModel) => (
                <MenuItem
                  key={`option-${processModel.id}`}
                  value={processModel.id}
                >
                  {processModel.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Grid>
      </Grid>
      <ProcessesList
        refresh={refresh}
        lastElementRef={lastElementRef}
        title={getTranslation(translations, "generic.processes.monitor")}
        processes={processes}
        filters={values}
        loading={loading}
      />
    </Stack>
  );
};

export default ProcessStarted;
